import { memo, useMemo } from "react";

import { COMPANY_LOGO } from "../../config/constants";
import { FEATURES, SCOPES } from "../../config/permission-maps";
import { getCompanyId } from "../../utils/cacheStorage";
import { hideSearchPath } from "../../utils/utils";
import { NotificationDropdown } from "../notification/NotificationDropdown";
import PermissionsGate from "../PermissionGate";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "../ui/common/dropdown-menu";
import { SidebarTrigger } from "../ui/common/sidebar";
import { CompanySearchDropdown } from "./CompanySearchDropdown";
import "./Header.scss";

// Desktop header. Rebuilt on Tailwind (no more Semantic UI Grid/Dropdown) so the
// bar itself is a plain flex row - only the company search field and the
// notification bell popover still delegate to their existing Semantic-backed
// components, which keeps their search/read behaviour untouched.
export const HeaderWebView = memo(
  ({
    options,
    userImage,
    navigate,
    company,
    getSearchValue,
    loadCompanyData,
    loadCompanyToken,
    searchCompany,
    notificationData,
    onClickNotification,
    isLogin
  }: any) => {
    const pathname = window.location.pathname;
    const companyId = useMemo(() => getCompanyId(), [searchCompany]);

    return (
      <div className="tw-scope tw-hidden min-[992px]:tw-flex tw-h-16 tw-w-full tw-items-center tw-justify-between tw-border-b tw-border-sidebar-border tw-bg-[#f9f9f4] tw-px-4">
        <div className="tw-flex tw-items-center tw-gap-3">
          {!isLogin && <SidebarTrigger />}
          <div className="tw-flex tw-cursor-pointer tw-items-center" onClick={() => navigate("/")}>
            <img src={COMPANY_LOGO} alt="logo" className="logo" />
          </div>
        </div>

        <div className="tw-flex tw-items-center tw-gap-4">
          <PermissionsGate scopes={[SCOPES.canAccessInHeaderMenu]} feature={FEATURES.companySearch}>
            {hideSearchPath(pathname) ? (
              <div className="tw-flex tw-items-center tw-gap-3">
                <CompanySearchDropdown
                  options={company}
                  value={companyId}
                  loading={loadCompanyData}
                  onOpen={() => searchCompany("")}
                  onSearchChange={query => searchCompany(query)}
                  onSelect={option => getSearchValue(option.other)}
                  onClose={() => searchCompany("")}
                />
                <NotificationDropdown
                  notification={notificationData}
                  onClick={onClickNotification}
                />
              </div>
            ) : null}
          </PermissionsGate>

          <DropdownMenu>
            <DropdownMenuTrigger className="tw-flex tw-items-center tw-gap-2 tw-rounded-md tw-p-1 tw-outline-none hover:tw-bg-muted">
              {userImage}
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              {options.map((option: any) => (
                <DropdownMenuItem key={option.key} onClick={() => option.onClick?.()}>
                  {option.text}
                </DropdownMenuItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    );
  }
);
